// Angular imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// 3rd party imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxFormModule,
    DxLoadPanelModule,
    DxMapModule,
    DxPopoverModule,
    DxSelectBoxModule,
    DxToolbarModule
} from 'devextreme-angular';

// Module imports
import { SharedModule } from '../shared-module/shared.module';
import { ManagementCommonModule } from '../management-common/management-common.module';
import { UserPortfolioRoutingModule } from './user-portfolio-routing.module';

// Service imports
import { PortfolioHelperService } from './_services/portfolio-helper.service';
import { UserCommunitiesService } from './_services/user-communities.service';

// Component imports
import { UserPortfolioMainComponent } from './user-portfolio-main/user-portfolio-main.component';
import { UserCommunitiesComponent } from './user-communities/user-communities.component';
import { UserCommunitiesMapComponent } from './user-communities-map/user-communities-map.component';
import { UserCommunityMapPopoverComponent } from './user-communities-map/user-community-map-popover/user-community-map-popover.component';
import { UserCloudDriveComponent } from './user-cloud-drive/user-cloud-drive.component';

@NgModule({
    imports: [
        CommonModule,
        DxBoxModule,
        DxButtonModule,
        DxFormModule,
        DxLoadPanelModule,
        DxMapModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxDataGridModule,
        DxPopoverModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        SharedModule,
        ManagementCommonModule,
        UserPortfolioRoutingModule
    ],
    declarations: [
        UserPortfolioMainComponent,
        UserCommunitiesComponent,
        UserCommunitiesMapComponent,
        UserCommunityMapPopoverComponent,
        UserCloudDriveComponent
    ],
    exports: [UserCommunitiesComponent],
    providers: [PortfolioHelperService, UserCommunitiesService]
})
export class UserPortfolioModule {}
